import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=b4e50228&"
import script from "./TemplateDetail.vue?vue&type=script&lang=js&"
export * from "./TemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports